var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronDownUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5406 13.2302C12.3992 13.0831 12.204 13 12 13C11.796 13 11.6008 13.0831 11.4594 13.2302L5.20938 19.7302C4.92228 20.0287 4.93159 20.5035 5.23017 20.7906C5.52875 21.0777 6.00353 21.0684 6.29063 20.7698L12 14.8321L17.7094 20.7698C17.9965 21.0684 18.4713 21.0777 18.7698 20.7906C19.0684 20.5035 19.0777 20.0287 18.7906 19.7302L12.5406 13.2302Z",
    fill: "#4A5256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11C12.204 11 12.3992 10.9169 12.5406 10.7698L18.7906 4.26983C19.0777 3.97125 19.0684 3.49647 18.7698 3.20938C18.4713 2.92228 17.9965 2.93159 17.7094 3.23017L12 9.16792L6.29063 3.23017C6.00353 2.93159 5.52875 2.92228 5.23017 3.20938C4.93159 3.49647 4.92228 3.97125 5.20938 4.26983L11.4594 10.7698C11.6008 10.9169 11.796 11 12 11Z",
    fill: "#4A5256"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownUp);
export default __webpack_public_path__ + "static/media/icon-chevron-down-up.76e6036d9215649630f84d710c379393.svg";
export { ForwardRef as ReactComponent };